export const parseBoolean = (value: string | null) =>
  value === 'true' || value === ''
export const parseNumber = (value: string | null) => {
  if (value === null) return null
  if (isNaN(Number(value))) {
    throw new Error(`Invalid number value: ${value}`)
  }
  return Number(value)
}
export const parseString = (value: string | null) =>
  value !== null ? value : null
